
import Radio from 'backbone.radio';
import Blinkup_Dialog from '@/views/dialogs/blinkup_dialog';
import session from '@/models/v5/session';
import ConfigId from '@/lib/blinkup/blinkupsdk/ConfigId';
import NetworkConfig from '@/lib/blinkup/blinkupsdk/NetworkConfig';
  
    export default function show_blinkup_dialog(login_info, account_id) {
        session.getPlanAndTokenId_ui(account_id).done(function(){
            var globalCh = Radio.channel('global');
            var devConfigId = new ConfigId({
                token: session.get('token_id'),
                planId: session.get('plan_id'),
                // planId: session.get('siteids')[0],
                apiKey: session.get("access_token"),
                environment: 'development'
            });
            
            var networkConfig = new NetworkConfig({
                ssid: login_info.ssid,
                password: login_info.password
            });

            globalCh.request('showDialog', new Blinkup_Dialog({
                devConfigId : devConfigId,
                networkConfig: networkConfig
            }));
        });

    }

